import { Injectable, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdminServiceService } from '../admin/service/admin-service.service';
import { UiService } from '../admin/service/ui.service';

@Injectable({
  providedIn: 'root'
})
export class LoadService {
  public uploadData = new EventEmitter()
  public sended = new EventEmitter()

  constructor(
    private uiSv: UiService,
    private adminSv: AdminServiceService,
  ) { }

  async uploadZip(file, type, typeFile, storeId){
    try{
      await this.uiSv.presentLoader();
      const formData = new FormData();
      formData.set('type', type);
      formData.set('storeId', storeId);
      formData.set('masive', file);
      const res: any = await this.adminSv.postLoad(formData, typeFile);
      const errors = res.data.filter(item => !item.status);
      const uploaded = res.data.filter(item => item.status);
      await this.uiSv.loading.dismiss();
      return { errors, uploaded }
    }catch(err){
      await this.uiSv.showToast(err.error.error);
      await this.uiSv.loading.dismiss();
    }
  }

  async uploadExcel( file, storeId ){
    try{
      await this.uiSv.presentLoader();
      const formData = new FormData();
      formData.set('file', file);
      formData.set('storeId', storeId);
      // formData.set('orden', excelData.orden);
      // formData.set('line', excelData.line);
      await this.adminSv.postLoad(formData);
      await this.uiSv.loading.dismiss();
      await this.uiSv.showToast('El archivo se ha subido con exito.');
      return true;
      // this.sended.emit();
    }catch(err){
      console.error(err);
      await this.uiSv.loading.dismiss();
      await this.uiSv.showToast('Ha ocurrido un error.');
      return false;
    }
  }
}
